import { Model } from 'pinia-orm';
import Interim from './Interim';

export default class InterimSection extends Model {

    static get entity() {
        return 'interim-sections';
    }

    static fields() {
        return {
            id: this.uid(() => null),
            company_id: this.attr(''),
            name: this.string(''),
            order: this.attr(0),
            visible: this.boolean(true),
            created_at: this.attr(null),
            updated_at: this.attr(null),

            // Relationships
            interims: this.hasMany(Interim, 'section_id'),
        };
    }
}
